<div class="relative inline-block">
  <button
    type="button"
    (click)="onClick($event)"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (focus)="onMouseEnter()"
    (blur)="onMouseLeave()"
    [attr.aria-label]="ariaLabel || title"
    [attr.disabled]="disabled ? true : null"
    [ngClass]="[sizeClass, 'flex', 'items-center', 'justify-center', 'rounded-full', bgClass, textClass, 'transition-colors', disabled ? 'opacity-50 pointer-events-none' : '']">
    <i [class]="iconClass + ' text-lg'"></i>
  </button>

  <div *ngIf="showTooltip" class="icon-tooltip">
    {{ title }}
  </div>
</div>

